import { useMemo } from 'react'
import { com } from '@eidu/web'
import AssetEditPage, { AssetPayloadConfig } from '../asset/AssetEditPage'
import { KindEditPageProps } from '../KindPages'
import FormPayloadEditor from './FormPayloadEditor'
import createFormSave from './formAssetSave'
import { usePostForm, usePostFormContent } from '../../../../io/useFormContent'
import getFormContent from '../../../../io/api/form/getFormContent'
import { useFormErrors } from '../../../../util/FormErrorBus'
import getFormContentId = com.eidu.entity.getFormContentId

/**
 * Routes the Form kind through the generic asset edit page while keeping the bespoke visual form editor. The save
 * choreography (seeding, validation gate, form-service dual-write) lives in the Form save module (formAssetSave);
 * this page only wires it into the asset config slots.
 */
const FormAssetEditPage = (props: KindEditPageProps) => {
  const { entity } = props
  const { hasErrors } = useFormErrors()
  const { postContent } = usePostFormContent()
  const { postForm } = usePostForm()

  const formId = entity?.entity.id.toString()
  const formContentId = entity ? getFormContentId(entity.entity)?.toString() : undefined

  const formSave = useMemo(
    () =>
      createFormSave({
        existingContent: formId && formContentId ? { formId, formContentId } : undefined,
        formService: { postForm, postContent, getContent: getFormContent },
      }),
    [formId, formContentId, postForm, postContent]
  )

  const config = useMemo<AssetPayloadConfig>(
    () => ({
      payloadExtension: 'yaml',
      payloadLabel: 'Form content',
      extraValid: !hasErrors,
      renderPayloadEditor: ({ value, onChange, editable, jsonSchema }) => (
        <FormPayloadEditor yaml={value} editable={editable} onChange={onChange} jsonSchema={jsonSchema} />
      ),
      seedContent: formSave.seedPayload,
      validatePayload: formSave.validatePayload,
      buildExtraLinks: formSave.buildContentLinks,
    }),
    [hasErrors, formSave]
  )

  return <AssetEditPage {...props} config={config} />
}

export default FormAssetEditPage
